import React from "react";
import { Label } from "@/components/ui/label";

export const Meta = ({ label, value }) => (
  <div>
    <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500">{label}</div>
    <div className="text-sm font-medium mt-0.5">{value}</div>
  </div>
);

export const Mini = ({ label, value }) => (
  <div className="px-2 first:pl-0">
    <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 mb-1">{label}</div>
    <div className="font-mono-plex text-xl">{value}</div>
  </div>
);

export const Field = ({ label, required, children }) => (
  <div className="space-y-2">
    <Label className="text-[10px] tracking-[0.25em] uppercase font-semibold">
      {label}{required && <span className="text-red-600 ml-1">*</span>}
    </Label>
    {children}
  </div>
);
